import update from 'immutability-helper';

import { RESET, SET_HAS_ERROR } from '../actions/actions.types';

let schema = {
  hasError: false,
  errorMessage: null,
  hasSuccess: false,
  successMessage: null,
};
let resetSchema = JSON.stringify(schema);

export default function UI(state = schema, action) {
  switch (action.type) {
    case RESET:
      return JSON.parse(resetSchema);
    case SET_HAS_ERROR:
      return update(state, {
        hasError: { $set: true },
        hasSuccess: { $set: false },
        errorMessage: { $set: action.errorMessage },
        successMessage: { $set: null },
      });
    default:
      return state;
  }
}
